<template>
  <button class="button-link" :class="[`button-link--${variant}`]" @click="$emit('click', $event)">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
  },
}
</script>
<style lang="scss" scoped>
    button.button-link {
        @apply inline-flex items-center;
        @apply text-primary-90 font-bold text-sm;
        @apply duration-150;
        transition-property: color, outline-offset;
        gap: 0.5rem;

        &:is(:hover, :focus) {
            @apply text-primary-110;
            outline: none;
        }

        &:where(:focus-visible):active {
            outline: revert;
        }

        &:where(:not(:active)):focus-visible {
            outline: revert;
            outline-offset: 5px;
        }

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
        &.button-link--base {
            @apply text-base-80 hover:text-base-90;
            &:active, &:focus {
                @apply text-base-100;
            }
        }
    }
</style>
